import {Injectable, Pipe, PipeTransform} from '@angular/core';


@Pipe({name: 'millisecondsToSeconds', standalone:true})

export class MillisecondsToSecondsPipe implements PipeTransform {
    transform(value: number): number {
        return value /1000;
    }
}
